import React, { useEffect } from 'react';
import { X } from 'lucide-react';

interface ModalWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const ModalWrapper: React.FC<ModalWrapperProps> = ({
  isOpen,
  onClose,
  children,
}) => {
  // Handle ESC key close
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  // Don’t render if modal is closed
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[150] flex items-center justify-center bg-black/50"
      onClick={onClose}
    >
      <div className="relative w-full h-full py-4 md:py-0">
        {/* Close Button (top-right corner of modal) */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white cursor-pointer z-51"
          aria-label="Close modal"
        >
          <X size={50} />
        </button>

        {/* Modal container */}
        <div
          className="w-full h-full overflow-y-auto px-2 pt-12"
          onClick={(e) => e.stopPropagation()} // Prevent outside click close
        >
          {/* Modal Content */}
          {children}
        </div>
      </div>
    </div>
  );
};
